import React from 'react';
import { Link } from 'react-router-dom';
import { Logout } from '../../../../../assets/images';

import Icon from '../../../core/Icon';
import Button from '../../../core/Buttons';

import { StyledWidgetLogout } from './style';

const WidgetLogout = className => (
  <StyledWidgetLogout className={className}>
    <h2 className="title">
      <Icon svg={Logout} className="icon-title" />
      Salir del widget
    </h2>
    <div className="box-logout">
      <p className="text">¿Seguro que desea salir de la aplicación?</p>
      <Link to="/widget/logout/exit">
        <Button ghost>Salir</Button>
      </Link>
    </div>
  </StyledWidgetLogout>
);

export default WidgetLogout;
